import React from "react";
import {twMerge} from "tailwind-merge";

interface DotProps {
  className?: string;
}

const Dot: React.FC<DotProps> = ({className}: DotProps) => {
  return (
    <div className={twMerge("bg-white h-1 w-1", className) + " rounded-full"}/>
  );
};

export default Dot;